<!--  -->
<template>
    <div class="hyper-table-box" :style="boxStyle">
      <table class="ht-table">
        <colgroup>
          <col
            v-if="config_.isCheck == true"
            style="width: 50px; min-width: 50px"
          />
          <col
            v-for="(item, index) in colgroupList_"
            :key="'colgroup-col-' + index"
            :style="item"
          />
        </colgroup>
        <thead class="ht-table-thead">
          <tr>
            <th v-if="config_.isCheck == true">
              <a-checkbox
                :indeterminate="indeterminate"
                :checked="checkAll"
                @change="onCheckAllChange"
              ></a-checkbox>
            </th>
            <th v-for="(item, index) in columns_" :key="'thead-tr-th-' + index" :style="{'text-align': item.align && item.align || 'left'}">
              {{ item.title }}
            </th>
          </tr>
        </thead>
        <tbody class="ht-table-tbody">
          <tr v-if="loading" class="example" :style="{height: '200px'}">
            <td :colspan="columns_.length + (config_.isCheck ? 1 : 0)">
              <a-spin tip="正在加载数据，请稍后..."/>
            </td>
          </tr>
          <tr v-if="tableData_.length == 0 && !loading" class="empty" :style="{height: '200px'}">
            <td :colspan="columns_.length + (config_.isCheck ? 1 : 0)">
              <a-empty description="暂无数据"/>
            </td>
          </tr>
          <tr
            v-for="(row, index) in tableData_"
            :key="'ht-table-row-' + index"
            class="ht-table-row"
            :user-data-s="row[rowKey]"
            :user-data-p="row[rowParentKey]"
            :deep="getdepth(row[rowKey])"
            :style="{ display: getExpand(row[rowParentKey]) }"
          >
            <td v-if="config_.isCheck == true" class="ht-table-row-cell">
              <a-checkbox :disabled="getCheckboxDisabled_(row,index)" v-model="checkedObj[row[rowKey]]" @change="(e) => {onChange(e, row, index);}"></a-checkbox>
            </td>
            <td v-for="(cell, index_) in columns_" :key="`row-cell-${index}-${index_}`" class="ht-table-row-cell" :style="{'text-align': cell.align && cell.align || 'left'}">
              <span v-if="config_.isTree == true && index_ == 0" :style="{ 'padding-left': `${getdepth(row[rowKey]) * indentSize}px` }"></span>
              <div v-if="config_.isTree == true && hasChild(row, index_, index)" @click="getRowChilds(row, index_, index)" :user-data-icon="row[rowKey]" :class="getRowDefaultClass(row[rowKey])"></div>
              <template v-if="getScopedSlots(cell, bodyCustomData)">
                <slot v-if="$scopedSlots[getScopedSlots(cell, bodyCustomData)]" :name="getScopedSlots(cell, bodyCustomData)" :row="row" :text="row[cell.dataIndex]" :rowIndex="index" :cellIndex="index_"></slot>
                <template v-else>
                  {{ getCellVal(cell, row, bodyCustomData, index_, index) }}
                </template>
              </template>
              <template v-else>
                {{ getCellVal(cell, row, bodyCustomData, index_, index) }}
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script>
  import {getNodeDepths} from "./../utils/util.js";
  import * as IS from './../utils/is.js'
  export default {
    name: "FYTable",
    components: {},
    props: {
      // [{title,dataIndex,key,customRender,width,scopedSlots,align}] 
      columns: { type: Array, default: () => { return []; }, },
      tableData: { type: Array },
      // 表格数据每一行的数据主键字段名称
      rowKey: { type: String, default: "id" },
      // 如果有父级结构时可以需要设置 父级id对应的字段名称
      rowParentKey: { type: String, default: "parentId" },
      isTree: { type: Boolean, default: false },
      isCheck: { type: Boolean, default: false },
      event:{type:Function},
      width:{type:[Number,String]},
      height:{type:[Number,String]},
      loading:{type:Boolean,default:false},
      // 展示树形数据时，每层缩进的宽度，以 px 为单位
      indentSize:{type:Number,default:20},
      // ()=> Boolean   返回值为true时，checkbox不可选 返回值为false时，checkbox可选
      getCheckboxDisabled:{type:Function},
      // 设置默认选中值 ids  可以是 主键id  也可以是当前行的数据对象  如果是动态设置的话需要再当前值变化之后更新一下tableData中的数据使table重新渲染
      setCheckboxDefaultValues:{type:Array}
    },
    data() {
      return {
        boxStyle:{
          width: '100%',
          height: '100%'
        },
        config_: {
          isTree: false,
          isCheck: false,
        },
        checkAll: false,
        indeterminate: false,
        checkedList: [],
        checkedObj: {},
        // defaultCheckedObj: {},
        // isSetDefaultVal: false,
        tableData_: [],
        columns_: [],
        colgroupList_: [],
        bodyCustomData: {},
        flattenData_: [],
        flattenDataObj_: {},
        tempKeyList_: {},
        tableDataKey:'',
      }
    },
    computed: {},
    watch: {
      columns: {
        handler(val) {
          if (!IS.isNullOrUnDef(val) && !IS.isEmpty(val)) {
            this.setColumns(val);
          }
        },
        deep: true,
        immediate: true,
      },
      tableData: {
        handler(val) {
          let tempTable = []
          if (!IS.isNullOrUnDef(val) && !IS.isEmpty(val)) {
            // const bodyCustom = JSON.parse(JSON.stringify(val))
            // this.setTableData(bodyCustom);
            tempTable = val
          }
          this.setTableData(tempTable);
        },
        deep: true,
        immediate: true,
      },
      isTree: {
        handler(val) {
          this.config_.isTree = val;
        },
        deep: true,
        immediate: true,
      },
      isCheck: {
        handler(val) {
          this.config_.isCheck = val;
        },
        deep: true,
        immediate: true,
      },
      width: {
        handler(val) {
          let temp = ''
          if(IS.isNumber(val)){
            temp = `${val}px`
          }
          if(IS.isString(val)){
            temp = val
          }
          this.boxStyle.width = temp
        },
        deep: true,
        immediate: true,
      },
      height: {
        handler(val) {
          let temp = ''
          if(IS.isNumber(val)){
            temp = `${val}px`
          }
          if(IS.isString(val)){
            temp = val
          }
          this.boxStyle.height = temp
        },
        deep: true,
        immediate: true,
      },
      setCheckboxDefaultValues: {
        handler(val) {
          if (!IS.isNullOrUnDef(val) && !IS.isEmpty(val)) {
            this.setCheckBoxDefaultVal(val);
          }
        },
        deep: true,
        immediate: true,
      },
    },
    created() {},
    mounted() {
      // console.log(this);
    },
    methods: {
      setCheckBoxDefaultVal(valArr){
        const temp = {}
        valArr.forEach(key=>{
          if(IS.isString(key)){
            temp[key] = true
          }
          if(IS.isNumber(key)){
            temp[key] = true
          }
          if(IS.isObject(key)){
            temp[key[this.rowKey]] = true
          }
        })
        this.checkedObj = temp
        // 什么时间调用事件  在table表格数据处理完成后调用
        // this.$nextTick(()=>{
        //   this.setCheckVal()
        // })
      },
      onChange(e, row, index){
          // console.log(e, row, index)
          this.checkedObj[row[this.rowKey]] = e.target.checked
          this.setSelected(row[this.rowKey],e.target.checked)
          if(e.target.checked==true){
              this.indeterminate = true
          }
          // let hasCheck = false
          // Object.keys(this.checkedObj).forEach(element => {
          //     const temp = this.checkedObj[element]
          //     if(temp==true){
          //         hasCheck = true
          //     }
          // });
          // if(hasCheck==false){
          //     this.indeterminate = false
          // }
          this.setCheckVal()
      },
      setCheckVal(type='1'){
        const tempArrKey = []
        const tempArrItem = []
        let hasCheck = false
        Object.keys(this.checkedObj).forEach(key=>{
            const temp = this.checkedObj[key]
            if(temp==true){
              tempArrKey.push(key)
              const tempRow = this.flattenDataObj_[key]
              if(!IS.isNullOrUnDef(tempRow)){
                tempArrItem.push(this.flattenDataObj_[key])
                hasCheck = true
              }
            }
        })
        if(type == '1' && hasCheck==false){
          this.indeterminate = false
        }
        this.event && this.event(tempArrKey,tempArrItem)
      },
      setSelected(currentNodeID,checked){
          const element = document.querySelector(`[user-data-s="${currentNodeID}"]`);
          if(checked==true){
              element.classList.add("ht-table-row-selected");
          }else{
              element.classList.remove("ht-table-row-selected");
          }
      },
      onCheckAllChange(e){
        const check = e.target.checked
        // checkedList: e.target.checked ? plainOptions : [],
        const tempObj = {}
        this.tableData_.forEach(item=>{
            const id = item[this.rowKey]
            tempObj[id] = check
            this.setSelected(id,check)
        })
        this.checkedObj = tempObj
        this.indeterminate = false
        this.checkAll = check
        this.setCheckVal('2')
      },
      getdepth(id) {
        const temp = this.flattenDataObj_[id];
      //   console.log('getdepth====>',id, temp.depth, temp);
        return (temp && temp.depth) || 0;
      },
      getDeepNum(row, cellIndex, rowIndex) {
        let res = "0px";
        if (cellIndex == 0) {
          const { children, id } = row;
          if (children && children.length > 0) {
            res = `${this.getdepth(id) * 20}px`;
          }
        }
        return res;
      },
      getExpand(id) {
        if(this.config_.isTree == false){
          return false
        }
        const { expand } = this.tempKeyList_[id] || {};
        let res = "";
        if (!IS.isNullOrUnDef(expand)) {
          if (expand == true) {
            res = "";
          } else {
            res = "none";
          }
        }
        return res;
      },
      getRowDefaultClass(id) {
        const { expand } = this.tempKeyList_[id] || {};
        let res = "ht-table-row-expand-icon";
        if (!IS.isNullOrUnDef(expand)) {
          if (expand == true) {
            res = "ht-table-row-expand-icon-n";
          } else {
            res = "ht-table-row-expand-icon";
          }
        }
        return res;
      },
      getRowChilds(row, cellIndex, rowIndex) {
        const { children } = row;
        const id = row[this.rowKey]
        const tempVAl = this.tempKeyList_[id];
      //   console.log(id, tempVAl,children,this.flattenDataObj_);
  
        if (tempVAl && tempVAl) {
          // 直接展开或隐藏
          this.upDataNodeAndChildNode(id,tempVAl.expand)
          this.setChildNode(id,tempVAl.expand)
          this.tempKeyList_[id].expand = !tempVAl.expand;
        } else {
          // 添加数据后展开
          this.tableData_.splice(rowIndex + 1, 0, ...children);
          this.tempKeyList_[id] = { children, expand: true };
        }
      },
      upDataNodeAndChildNode(currentNodeID, expand) {
        const iconNode = document.querySelector(`[user-data-icon="${currentNodeID}"]`);
        if(expand && expand==true){
          iconNode && (iconNode.className  = 'ht-table-row-expand-icon')
        }else{
          iconNode && (iconNode.className  = 'ht-table-row-expand-icon-n')
        }
        
      },
      setChildNode(currentNodeID, expand) {
          const elements = document.querySelectorAll(`[user-data-p="${currentNodeID}"]`);
          if(expand && expand==true){
              elements.forEach((element) => {
                  element.style.display = 'none'
              });
              const {children} = this.tempKeyList_[currentNodeID]||{}
              if(children && children.length>0){
                  children.forEach((element) => {
                      const id = element[this.rowKey]
                      this.setChildNode(id,expand)
                      this.upDataNodeAndChildNode(id,expand)
                  });
              }
          }else{
              elements.forEach((element) => {
                  element.style.display = ''
              });
          }
      },
  
      hasChild(row, cellIndex, rowIndex) {
        let res = false;
        if (cellIndex == 0) {
          const { children } = row;
          if (children && children.length > 0) {
            res = true;
          }
        }
        return res;
      },
      getCellVal(cell, row, bodyCustomData, cellIndex, rowIndex) {
        const { dataIndex } = cell;
        const { customRender } = bodyCustomData[dataIndex];
        const tempCellVal = row[dataIndex];
        let res = tempCellVal;
        if (customRender) {
          res = customRender(tempCellVal);
        }
  
        return res;
      },
      getScopedSlots(cell, bodyCustomData) {
        const { dataIndex } = cell;
        const { scopedSlots } = bodyCustomData[dataIndex];
        let SlotsName = null;
        if (scopedSlots && scopedSlots.customRender) {
          SlotsName = scopedSlots.customRender;
        }
        return SlotsName;
      },
      getCheckboxDisabled_(row,rowIndex){
        let res = false
        this.getCheckboxDisabled && (res = this.getCheckboxDisabled(row))
        return res
      },
      // setCheckboxValue_(row,rowIndex){
      //   let res = false
      //   this.setCheckboxValue && (res = this.setCheckboxValue(row))
      //   if(res == true){
      //     this.defaultCheckedObj[row[this.rowKey]] = res
      //   }
      // },
      setColumns(colummList) {
        const columList = [];
        const colgroupList = [];
        const tempObj = {};
        colummList.forEach((element) => {
          const { key, title, align, dataIndex, scopedSlots, customRender, width } =
            element;
          if (width) {
            let tempw = "";
            if (IS.isString(width)) {
              tempw = width;
            }
            if (IS.isNumber(width)) {
              tempw = `${width}px`;
            }
            colgroupList.push({ width: tempw, "min-width": tempw });
          } else {
            colgroupList.push({});
          }
          columList.push({ title, dataIndex, key,align });
          tempObj[dataIndex] = { scopedSlots, customRender };
        });
        this.colgroupList_ = colgroupList;
        this.columns_ = columList;
        this.bodyCustomData = tempObj;
      },
      setTableData(dataList) {
        const tempObj = getNodeDepths(dataList)
        const bodyCustom = JSON.parse(JSON.stringify(tempObj))
        this.tableData_ = dataList
        this.flattenDataObj_ = bodyCustom;
        if(!IS.isEmpty(this.setCheckboxDefaultValues)){
          this.$nextTick(()=>{
            this.setCheckVal()
          })
        }
      },
    },
  };
  </script>
  <style lang="less" scoped>
  .hyper-table-box {
  //   width: 1500px;
  //   height: 500px;
    overflow: visible;
    // overflow: auto;
    box-sizing: border-box;
    .ht-table {
      border: 1px solid #e8e8e8;
      width: 100%;
      box-sizing: content-box;
      margin: 0;
      padding: 0;
      color: rgba(0, 0, 0, 0.65);
      font-size: 14px;
      font-variant: tabular-nums;
      line-height: 1.5;
      list-style: none;
      font-feature-settings: "tnum";
      position: relative;
      box-sizing: border-box;
      table-layout: fixed;
      .ht-table-thead {
        tr {
          position: sticky;
          top: -1px;
          background-color: #fafafa;
          z-index: 10;
          th {
            border-right: 1px solid #e8e8e8;
            color: rgba(0, 0, 0, 0.85);
            font-weight: 500;
            text-align: left;
            background: #fafafa;
            border-bottom: 1px solid #e8e8e8;
            transition: background 0.3s ease;
  
            padding: 16px;
            overflow-wrap: break-word;
            border-top: 1px solid #e8e8e8;
          }
        }
        tr:first-child {
          th:first-child {
            border-top-left-radius: 4px;
          }
          th:last-child {
            border-top-right-radius: 4px;
          }
        }
      }
  
      .ht-table-tbody {
        .ht-table-row {
          transition: background 0.3s;
          z-index: 0;
          position: relative;
          .ht-table-row-cell {
            padding: 16px;
            border-bottom: 1px solid #e8e8e8;
            transition: background 0.3s;
            border-right: 1px solid #e8e8e8;
  
            word-wrap: break-word;
            overflow-wrap: break-word;
          }
        }
        .ht-table-row:hover{
          background: #f5f5f5;
        }
      }
      .example {
        text-align: center;
        background: rgba(0, 0, 0, 0.05);
        border-radius: 4px;
        // padding: 30px 50px;
      }
      .empty {
        text-align: center;
        border-radius: 4px;
        // padding: 30px 50px;
      }
      .ht-table-row-selected {
        background: #f5f5f5;
      }
      .ht-table-row-expand-icon,
      .ht-table-row-expand-icon-n {
        color: #1890ff;
        text-decoration: none;
        cursor: pointer;
        transition: color 0.3s;
        display: inline-block;
        width: 17px;
        height: 17px;
        color: inherit;
        line-height: 13px;
        text-align: center;
        background: #fff;
        border: 1px solid #e8e8e8;
        border-radius: 2px;
        outline: none;
        transition: all 0.3s;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
      }
      .ht-table-row-expand-icon::after {
        content: "+";
      }
      .ht-table-row-expand-icon-n::after {
        content: "-";
      }
      .ht-table-row-expand-icon:hover {
        color: #40a9ff;
      }
      .ht-table-row-cell-ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  </style>
  